import type { AxisSelection } from '@atlas/types'

/**
 * Split one rail selection into the two channels discovery takes: `filters` for
 * DIMENSION axes (matched against an object's classification tags, subtree-aware) and
 * `attributeFilters` for ATTRIBUTE axes (matched against its `object_attribute` values).
 *
 * The rail offers both kinds side by side — a user picking `channel` and `aspect_ratio`
 * has no reason to know they are stored differently — but the read does not resolve one
 * from the other, so an attribute axis left in `filters` narrows to nothing. The axis
 * registry is the only thing that knows which is which, hence `attributeAxisCodes`.
 *
 * Axes selected with no values are dropped: an empty list means "no constraint", not
 * "narrow to nothing".
 */
export function partitionAxisSelection(
	selection: AxisSelection,
	attributeAxisCodes: ReadonlySet<string>,
): { filters: AxisSelection; attributeFilters: AxisSelection } {
	const filters: AxisSelection = {}
	const attributeFilters: AxisSelection = {}
	for (const [axisCode, valueCodes] of Object.entries(selection)) {
		if (!valueCodes?.length) continue
		if (attributeAxisCodes.has(axisCode)) attributeFilters[axisCode] = valueCodes
		else filters[axisCode] = valueCodes
	}
	return { filters, attributeFilters }
}
